module.exports = __webpack_public_path__ + "img/99.471e50f6.jpg";